import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type RejectSuggestionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.RejectSuggestionInput;
}>;

export type RejectSuggestionMutationResult = { __typename?: 'Mutation' } & {
  rejectSuggestion?: GraphQLTypes.Maybe<
    { __typename?: 'RejectSuggestionPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>>;
    }
  >;
};

export const RejectSuggestionDocument = gql`
  mutation rejectSuggestion($input: RejectSuggestionInput!) {
    rejectSuggestion(input: $input) {
      errors {
        message
      }
    }
  }
`;
